import React from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Avatar from "../../Assests/Images/avatar.svg";
import { useTheme } from "@mui/material/styles";
import Header from "../../Components/Header";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import Alert from "../../Components/Alert";
import { useState } from "react";


const USER_ID = `${process.env.REACT_APP_USER_ID}`;
const SERVICE_ID = `${process.env.REACT_APP_SERVICE_ID}`;
const TEMPLATE_ID = `${process.env.REACT_APP_TEMPLATE_ID}`;

function ContactForm() {
  const form = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [popMessage, setPopMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("error");

  const openToaster = (message, code) => {
    if (code === 200) setSeverity("success");
    else setSeverity("error");
    setPopMessage(message);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID)
      .then((result) => {
        openToaster("Message sent successfully!", 200);
        e.target.reset();
      })
      .catch((error) => {
        openToaster("Failed to send message. Please try again later.", 500);
      });
      
  };

  return (
    <div>
      <Header />
      <div style={{ marginTop: isMobile ? "-20px" : "-60px", marginBottom: isMobile ? "50px" : "20px", }}>
        <section>
          <Container>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8} textAlign="center">
                <img
                  src={Avatar}
                  alt="Avatar"
                  style={{
                    width: isMobile ? "100px" : "150px",
                    marginBottom: isMobile ? "20px" : "40px",
                  }}
                />
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  component="h1"
                  gutterBottom
                  sx={{
                    fontFamily: "Font1",
                    fontWeight: 800,
                    color: "#141c3a",
                    mb: "40px",
                  }}
                >
                  Thanks for taking the time to reach out. How can I help you
                  today?
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section>
          <Container sx={{ width: isMobile ? "100%" : "50%" }}>
            <form ref={form} onSubmit={handleSubmit}>
              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    name="from_name"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    name="reply_to"
                    type="email"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Message"
                    name="message"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <input type="hidden" name="bot_vortex" />
                  <Button
                  type="submit"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      borderRadius: "60px",
                      border: "2px solid #6E07F3",
                      color: "#6E07F3",
                      fontSize: isMobile ? "14px" : "18px",
                      padding: isMobile ? "6px 20px" : "8px 25px",
                      "&:hover": {
                        backgroundColor: "#6E07F3",
                        color: "white",
                        border: "2px solid #6E07F3",
                      },
                      textTransform: "none",
                      fontFamily: "Font2",
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Container>
        </section>
      </div>
      <Alert message={popMessage} open={open} severity={severity} />
    </div>
  );
}

export default ContactForm;
